import React, { useEffect, useState } from 'react';

import { useSnackbar } from '@hooks/useSnackbar';

import { ContainerStyle } from './SnackbarContainer.style';
import { Snackbar } from './index';

function SnackbarContainer() {
  // Keep track of latest count
  const [counter, setCounter] = useState(-1);

  // Get snacks
  const {
    dequeueSnackbar,
    state: { snackbars },
  } = useSnackbar();

  const snackbarKey = JSON.stringify(snackbars);

  // Check when new snackbar added, set timeout if new
  useEffect(() => {
    let newCounter = counter;

    snackbars.forEach(({ id, isPersistent }) => {
      if (id > counter && !isPersistent) {
        setTimeout(() => dequeueSnackbar(id), 10000);
        if (id > newCounter) {
          newCounter = id;
        }
      }
    });

    setCounter(newCounter);
    return () => {
      snackbars.forEach(({ id, isPersistent }) => {
        // Close persistent snackbars on page change
        if (isPersistent) {
          setTimeout(() => dequeueSnackbar(id), 10000);
          if (id > newCounter) {
            newCounter = id;
          }
        }
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [snackbarKey, counter]);

  function handleClick(id: number) {
    dequeueSnackbar(id);
  }

  // Render
  return (
    <ContainerStyle>
      {snackbars.map(({ message, variant, id }) => (
        <Snackbar
          key={id}
          message={message}
          onClick={() => handleClick(id)}
          variant={variant}
        />
      ))}
    </ContainerStyle>
  );
}

export default SnackbarContainer;
